module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-28.cf9d5841.png";